import { render, staticRenderFns } from "./asset-allocations.vue?vue&type=template&id=b455e6e8&"
import script from "./asset-allocations.vue?vue&type=script&lang=js&"
export * from "./asset-allocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports